import PayDistributionStep from "./PayDistributionStep";

export default PayDistributionStep;
